import { __decorate } from "tslib";
import { proxy, subscribe } from '@/infrastructure/object-reactive/object-reactive';
import { injectable } from '@/inversify.config';
import _ from 'lodash';
let UserCapacityModelImpl = class UserCapacityModelImpl {
    constructor() {
        this._userCapacity = proxy(null);
    }
    get userCapacity() {
        return this._userCapacity.value;
    }
    updateUserCapacity(userCapacity) {
        this._userCapacity.value = {
            ...userCapacity,
        };
    }
    getUserCapacityByKey(key) {
        return _.get(this.userCapacity, key, 0);
    }
    subscribeUserCapacity(callback) {
        const dispose = subscribe(() => this._userCapacity.value, (newVal) => {
            callback(newVal);
        });
        return dispose;
    }
};
UserCapacityModelImpl = __decorate([
    injectable()
], UserCapacityModelImpl);
export { UserCapacityModelImpl };
